import React, {useEffect, useState} from 'react';
import {useLazyQuery} from '@apollo/client';
import {query} from '../../services/queries/queries';
import {IndustryI, TacticI, TenantI} from '../../interfaces/general';
import {tagStyle} from '../../styles/classes';
import CloseIcon from '../../assets/Icons/Interface/CloseIcon';

interface SelectorI {
	selected: string[]
	setSelected : (s:string[]) => void
}

export default function SegmentsSelector({selected, setSelected}:SelectorI) {

	const [loading, setLoading] = useState<boolean>(true);
	const [entries, setEntries] = useState<IndustryI[]>();

	const [findSegments, { data }] = useLazyQuery(query("industrySegmentFindMany"));

	useEffect(()=>{
		if(loading){
			findSegments({
				variables: {},
				fetchPolicy: 'no-cache',
				onCompleted: (data:any):void => {
					setEntries(data?.industrySegmentFindMany);
					setLoading(false);
				}
			});
		}
	},[loading]);

	const addSelected = (id:string) => {
		const s:string[] = [...selected];

		const f = s.find((e:string):boolean => e===id );
		if(!f){
			s.push(id);
			setSelected(s);
		}
	}

	const removeSelected = (id:string) => {
		const s:string[] = [...selected];
		const index:number = s.findIndex(x => x === id);
		if (index !== -1) {
			s.splice(index, 1);
			setSelected(s);
		}
	}

	const getLabel = (id:string) => {
		const t = entries?.find((e:any)=>e._id === id);
		return t ? t.label : id
	}

	return (
		<div>
			<select onChange={(e)=>addSelected(e.target.value)}>
				<option value={''}>Select one...</option>
				{entries && entries?.length > 0 && entries?.map(({_id, label}:IndustryI)=>{
					return (
						<option key={_id} value={_id}>
							{label}
						</option>
					)
				})}
			</select>

			{!loading &&
				<div className="flex align-center mt">
					{selected && selected.length > 0 && selected.map((id:string, index)=>{
						return (
							<div className={`${tagStyle} flex align-center`} key={`${id}-${index}`} onClick={()=>removeSelected(id)}>
								{getLabel(id)}
								<span className="ml-half">
									<CloseIcon size={10} className="white" />
								</span>
							</div>
						)
					})}
				</div>
			}
		</div>
	)
}
